import superiorDireito from "../../assets/superiorDireito.png";
import inferiorDireito from "../../assets/inferiorDireito.png";
import centroEsquerdo from "../../assets/centroEsquerdo.png";
import { Button } from "react-bootstrap";
import Cookies from "js-cookie";
import style from "./RedefinirInformacoesUsuarioPrimeiroLogin.module.css";
import { useState, useEffect } from "react";
import Logo from "../../assets/logoItera.png";
import Alerta from "../../components/alerta/Alerta";
import { z } from "zod";
import UsuarioApi from "../../services/UsuarioApi";
import { Link, useNavigate } from "react-router-dom";
import InputMask from "react-input-mask";
import Loader from "../../components/loader/Loader";
import InputNovaSenha from "../../components/inputNovaSenha/InputNovaSenha";

export default function RedefinirInformacoesUsuarioPrimeiroLogin() {
  const [mostrarAlerta, setMostrarAlerta] = useState(false);
  const [mensagemAlerta, setMensagemAlerta] = useState("");
  const [tipoAlerta, setTipoAlerta] = useState("");
  const [aceitouTermos, setAceitouTermos] = useState(false);
  const [loading, setLoading] = useState(false);



  const [botaoRedefinirInativo, setBotaoRedefinirInativo] = useState(true);

  const [pessoaAtualizarPrimeiroLogin, setPessoaAtualizarPrimeiroLogin] =
    useState({
      nomeCompleto: "",
      nomeContato: "",
      cpf: "",
      rg: "",
      dataDeNascimento: "",
    });

  const [enderecoAtualizarPrimeiroLogin, setEnderecoAtualizarPrimeiroLogin] =
    useState({
      cep: "",
      logradouro: "",
      bairro: "",
      numero: 0,
      cidade: "",
      uf: "",
      complemento: "",
    });

  const [telefoneAtualizarPrimeiroLogin, setTelefoneAtualizarPrimeiroLogin] =
    useState({
      numero: "",
    });

  const [
    verificarEnderecoPrincipalValido,
    setVerificarEnderecoPrincipalValido,
  ] = useState(false);

  const [verificarEnderecoValido, setVerificarEnderecoValido] = useState(false);
  const [senha, setSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");

  const navigate = useNavigate();

  // Função para fazer as verificações de senha
  const schema = z.object({
    senha: z
      .string()
      .min(8, "Mínimo 8 caracteres.")
      .regex(/[A-Z]/, "A senha deve conter pelo menos uma letra maiúscula.")
      .regex(/[0-9]/, "A senha deve conter pelo menos um número.")
      .regex(
        /[^A-Za-z0-9]/,
        "A senha deve conter pelo menos um caractere especial."
      ),
  });

  //Função de exibir alerta
  function exibirAlerta(mensagem, tipoAlerta) {
    setMensagemAlerta(mensagem);
    setTipoAlerta(tipoAlerta);
    setMostrarAlerta(true);
    setTimeout(() => {
      setMostrarAlerta(false);
    }, 3000);
  }

  // Função para validar a senha
  function validarSenha() {
    const resultado = schema.safeParse({ senha, confirmarSenha });

    if (!resultado.success) {
      const mensagensErro = resultado.error.issues
        .map((issue) => issue.message)
        .join("\n");
      exibirAlerta(mensagensErro, "danger");
      return false;
    }
    return true;
  }

  // Função para limpar documentos como cpf e rg para salvar sem . ou - ou qualquer coisa que não seja numero
  const limparDocumento = (documento) => {
    return documento.replace(/\D/g, ""); // Remove tudo que não for número
  };

  // Função para redefinir as informações de primeiro login
  async function RedefinirInformacoesPrimeiroLogin(e) {
    e.preventDefault();
    const tokenString = Cookies.get("token");

    if (validarSenha() && aceitouTermos) {
      try {
        //Criação dos objetos e variavei que vao ser enviadas para o Back-End
        const usuarioAtualizarPrimeiroLogin = {
          senha: senha,
          nomeCompleto: pessoaAtualizarPrimeiroLogin.nomeCompleto,
        };
        pessoaAtualizarPrimeiroLogin.cpf = limparDocumento(
          pessoaAtualizarPrimeiroLogin.cpf
        );
        pessoaAtualizarPrimeiroLogin.rg = limparDocumento(
          pessoaAtualizarPrimeiroLogin.rg
        );
        const tokenObjeto = JSON.parse(tokenString);
        setLoading(true);
        await UsuarioApi.atualizarInformacoesUsuarioPrimeiroLogin(
          usuarioAtualizarPrimeiroLogin,
          pessoaAtualizarPrimeiroLogin,
          enderecoAtualizarPrimeiroLogin,
          telefoneAtualizarPrimeiroLogin,
          tokenObjeto.jwt
        );

        await UsuarioApi.atualizarTokenLogin(
          usuarioAtualizarPrimeiroLogin.senha,
          tokenObjeto.jwt
        );

        exibirAlerta("Informações atualizadas com sucesso!", "success");

      } catch (error) {
        console.error("Error during information update:", error);
        const mensagemErro = error.response
          ? error.response.data
          : "Erro ao atualizar informações.";
        exibirAlerta(mensagemErro, "danger");
      } finally {
        setLoading(false);
      }
    }
  }

  // Função para buscar endereço pelo CEP
  async function buscarCEP(cep) {
    try {

      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const data = await response.json();

      if (data?.logradouro === "") {
        setVerificarEnderecoValido(false);
        if (data?.cidade === "") {
          setVerificarEnderecoPrincipalValido(false);
        } else {
          setVerificarEnderecoPrincipalValido(true);
        }
      } else if (data?.logradouro !== "") {
        setVerificarEnderecoValido(true);
        setVerificarEnderecoPrincipalValido(true);
      }

      if (!data?.erro) {
        setEnderecoAtualizarPrimeiroLogin((prevState) => ({
          ...prevState,
          cep: data.cep,
          logradouro: data.logradouro,
          bairro: data.bairro,
          cidade: data.localidade,
          uf: data.uf,
        }));
        exibirAlerta("CEP Encontrado com sucesso", "success")
      } else {
        exibirAlerta("CEP não encontrado.", "danger");
      }
    } catch (error) {
      console.error("Erro ao buscar:", error);
    }
  }

  useEffect(() => {
    const rg = pessoaAtualizarPrimeiroLogin.rg.replace(/\D/g, "");

    if (senha === "" || confirmarSenha === "" || !aceitouTermos || rg === "") {
      setBotaoRedefinirInativo(false); // Desativa se algum obrigatório estiver vazio
    } else {
      setBotaoRedefinirInativo(senha === confirmarSenha && aceitouTermos);
    }
  }, [senha, confirmarSenha, aceitouTermos, pessoaAtualizarPrimeiroLogin.rg]);

  //Pega todos os dados
  const PegarDadosPessoa = (e) => {
    const { id, value } = e.target;
    setPessoaAtualizarPrimeiroLogin((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };
  const PegarDadosEndereco = (e) => {
    const { id, value } = e.target;
    setEnderecoAtualizarPrimeiroLogin((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };
  const PegarDadosTelefone = (e) => {
    const { id, value } = e.target;
    setTelefoneAtualizarPrimeiroLogin((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };
  const PegarValorCep = (e) => {
    const cep = e.target.value;
    setEnderecoAtualizarPrimeiroLogin((prevState) => ({
      ...prevState,
      cep: cep,
    }));
    if (cep.length === 9) {
      buscarCEP(cep.replace("-", ""));
    } else {
      setVerificarEnderecoValido(false);
      setVerificarEnderecoPrincipalValido(false);
    }
  };

  return (
    <div className={style.conteudo}>
      <Alerta
        tipo={tipoAlerta}
        mensagem={mensagemAlerta}
        visivel={mostrarAlerta}
        aoFechar={() => setMostrarAlerta(false)}
      />
      {loading && <Loader />}
      <div className={style.conteudo_esquerda}>
        <img
          src={centroEsquerdo}
          alt="centroEsquerdo"
          className={style.centro_esquerdo}
        />
      </div>

      <div className={style.conteudo_total}>
        <img src={Logo} alt="logo" className={style.imagem_logo} />
        <div className={style.texto_info} >
          <h2 className={style.titulo_redefinir}>Preencha seus dados</h2>
          <p className={style.subtitulo_redefinir}>
            Como este é seu primeiro acesso, por favor, preencha seus dados para continuar.
          </p>
        </div>
        <form
          className={style.container_formulario}
          onSubmit={RedefinirInformacoesPrimeiroLogin}
        >
          {/* Primeira Linha */}
          <div className={style.row_formulario}>
            <div className={`${style.form_group} ${style.nome_completo}`}>
              <label htmlFor="nomeCompleto">Nome Completo<span className={style.asteriscoObrigatorio}>*</span></label>
              <InputNovaSenha
                type="text"
                id="nomeCompleto"
                maxLength={100}
                placeholder="Nome Completo"
                name="nomeCompleto"
                value={pessoaAtualizarPrimeiroLogin.nomeCompleto}
                onChange={PegarDadosPessoa}
                required
                className={style.input}
              />
            </div>

            <div className={`${style.form_group} ${style.nome_contato}`}>
              <label htmlFor="nomeContato">Nome Social<span className={style.asteriscoObrigatorio}>*</span></label>
              <InputNovaSenha
                type="text"
                id="nomeContato"
                placeholder="Nome de contato"
                value={pessoaAtualizarPrimeiroLogin.nomeContato}
                onChange={PegarDadosPessoa}
                maxLength={100}
                required
                className={style.input}
              />
            </div>
          </div>

          {/* Segunda Linha */}
          <div className={style.row_formulario}>
            <div className={`${style.form_group} ${style.telefone}`}>
              <label htmlFor="telefone">Telefone<span className={style.asteriscoObrigatorio}>*</span></label>
              <InputMask
                mask="(99) 9 9999-9999"
                type="text"
                id="numero"
                placeholder="(99) 9 9999-9999"
                value={telefoneAtualizarPrimeiroLogin.numero}
                onChange={PegarDadosTelefone}
                required
                className={style.input}
              >
                {(inputProps) => (
                  <input {...inputProps} className={style.input} />
                )}
              </InputMask>
            </div>

            <div className={`${style.form_group} ${style.cpf}`}>
              <label htmlFor="cpf">CPF<span className={style.asteriscoObrigatorio}>*</span></label>
              <InputMask
                mask="999.999.999-99"
                type="text"
                id="cpf"
                placeholder="999.999.999-99"
                value={pessoaAtualizarPrimeiroLogin.cpf}
                onChange={PegarDadosPessoa}
                required
                className={style.input}
              >
                {(inputProps) => (
                  <input {...inputProps} className={style.input} />
                )}
              </InputMask>
            </div>

            <div className={`${style.form_group} ${style.rg}`}>
              <label htmlFor="rg">RG<span className={style.asteriscoObrigatorio}>*</span></label>
              <InputNovaSenha
                type="text"
                id="rg"
                maxLength={13}
                placeholder="RG"
                inputMode="numeric"
                value={pessoaAtualizarPrimeiroLogin.rg}
                onChange={(e) =>
                  setPessoaAtualizarPrimeiroLogin((prevState) => ({
                    ...prevState,
                    rg: e.target.value.replace(/\D/g, ""),
                  }))
                }
                className={style.input}
              />
            </div>

            <div className={`${style.form_group} ${style.data_nacimento}`}>
              <label htmlFor="dataNacimento">Data de Nacimento<span className={style.asteriscoObrigatorio}>*</span></label>
              <InputNovaSenha
                maxLength={8}
                type="date"
                id="dataDeNascimento"
                value={pessoaAtualizarPrimeiroLogin.dataDeNascimento}
                onChange={PegarDadosPessoa}
                className={style.input}
                min="1900-01-01"
                max="2099-12-31"
              />
            </div>
          </div>

          {/* Terceira Linha */}
          <div className={style.row_formulario}>
            <div className={`${style.form_group} ${style.cep}`}>
              <label htmlFor="cep">CEP<span className={style.asteriscoObrigatorio}>*</span></label>
              <InputMask
                mask="99999-999"
                type="text"
                id="cep"
                placeholder="00000-000"
                value={enderecoAtualizarPrimeiroLogin.cep}
                onChange={(e) => PegarValorCep(e)}
                required
                className={style.input}
              >
                {(inputProps) => (
                  <input {...inputProps} className={style.input} />
                )}
              </InputMask>
            </div>

            <div className={`${style.form_group} ${style.bairro}`}>
              <label htmlFor="bairro">Bairro<span className={style.asteriscoObrigatorio}>*</span></label>
              <input
                type="text"
                id="bairro"
                placeholder="Bairro"
                value={enderecoAtualizarPrimeiroLogin.bairro}
                onChange={PegarDadosEndereco}
                required
                readOnly={verificarEnderecoValido}
                className={style.input}
              />
            </div>

            <div className={`${style.form_group} ${style.cidade}`}>
              <label htmlFor="cidade">Cidade<span className={style.asteriscoObrigatorio}>*</span></label>
              <input
                type="text"
                id="cidade"
                placeholder="Cidade"
                value={enderecoAtualizarPrimeiroLogin.cidade}
                onChange={PegarDadosEndereco}
                required
                readOnly={verificarEnderecoPrincipalValido}
                className={style.input}
              />
            </div>

            <div className={`${style.form_group} ${style.estado}`}>
              <label htmlFor="uf">UF<span className={style.asteriscoObrigatorio}>*</span></label>
              <input
                type="text"
                id="uf"
                placeholder="MG"
                value={enderecoAtualizarPrimeiroLogin.uf}
                onChange={PegarDadosEndereco}
                required
                readOnly={verificarEnderecoPrincipalValido}
                className={style.input}
              />
            </div>
          </div>

          {/* Quarta Linha */}
          <div className={style.row_formulario}>
            <div className={`${style.form_group} ${style.logradouro}`}>
              <label htmlFor="logradouro">Logradouro<span className={style.asteriscoObrigatorio}>*</span></label>
              <input
                type="text"
                id="logradouro"
                placeholder="ex: Rua, Avenida..."
                value={enderecoAtualizarPrimeiroLogin.logradouro}
                onChange={PegarDadosEndereco}
                required
                readOnly={verificarEnderecoValido}
                className={style.input}
              />
            </div>

            <div className={`${style.form_group} ${style.numero}`}>
              <label htmlFor="numero">Numero<span className={style.asteriscoObrigatorio}>*</span></label>
              <InputNovaSenha
                type="number"
                id="numero"
                placeholder="Numero"
                value={enderecoAtualizarPrimeiroLogin.numero}
                onChange={PegarDadosEndereco}
                inputMode="numeric"
                required
                className={style.input}
              />
            </div>

            <div className={`${style.form_group} ${style.complemento}`}>
              <label htmlFor="complemento">Complemento<span className={style.asteriscoObrigatorio}>*</span></label>
              <InputNovaSenha
                maxLength={20}
                type="text"
                id="complemento"
                placeholder="Complemento"
                value={enderecoAtualizarPrimeiroLogin.complemento}
                onChange={PegarDadosEndereco}
                required
                className={style.input}
              />
            </div>
          </div>

          {/* Quinta Linha */}
          <div className={style.row_formulario}>
            <div className={`${style.form_group} ${style.senha}`}>
              <label htmlFor="senha">Senha<span className={style.asteriscoObrigatorio}>*</span></label>
              <InputNovaSenha
                maxLength={50}
                type="password"
                id="senha"
                placeholder="Senha"
                name="senha"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                required
                className={style.input}
              />
            </div>

            <div className={`${style.form_group} ${style.confirmar_senha}`}>
              <label htmlFor="confirmarSenha">Confirmar Senha<span className={style.asteriscoObrigatorio}>*</span></label>
              <InputNovaSenha
                maxLength={50}
                type="password"
                id="confirmarSenha"
                placeholder="Confirmar Senha"
                name="confirmarSenha"
                value={confirmarSenha}
                onChange={(e) => setConfirmarSenha(e.target.value)}
                required
                className={style.input}
              />
            </div>
          </div>
          <div className={style.termos}>
            <div className={style.chekbox}>
              <input
                type="checkbox"
                id="aceitarTermos"
                name="aceitarTermos"
                checked={aceitouTermos}
                onChange={(e) => setAceitouTermos(e.target.checked)}
              />
              <label className="termosLabel" htmlFor="aceitarTermos">
                Eu li e aceito os{" "}
                <Link to="/termos" target="_blank" rel="noopener noreferrer">
                  termos de uso
                </Link>
              </label>

            </div>
            <div>
              <small className={style.asteriscoObrigatorio}> * Campos Obrigatorio</small>
            </div>

          </div>

          <Button
            disabled={!botaoRedefinirInativo}
            variant="primary"
            type="submit"
            id={style.botao_entrar}
          >
            Salvar Informações
          </Button>
        </form>
      </div>

      <div className={style.conteudo_direita}>
        <img
          src={superiorDireito}
          alt="superiorDireito"
          className={style.superior_direito}
        />
        <img
          src={inferiorDireito}
          alt="inferiorDireito"
          className={style.inferior_direito}
        />
      </div>
    </div>
  );
}
